import React from 'react'
import palette from 'src/designSystem/variables/palette'
import styled, { css } from 'styled-components/macro'

export const ActionButtonGroupContainer = styled.div<{
  $useNewStyle?: boolean
}>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 16px;

  ${({ $useNewStyle }) =>
    $useNewStyle &&
    css`
      justify-content: flex-end;
      background-color: ${palette.neutral.white};
      border-radius: 50px;
      height: 40px;
      align-items: center;
      justify-content: center;
      padding: 16px 32px;
      box-shadow: 0px 0px 2px 0px rgba(198, 198, 198, 1);

      button {
        width: 18px;
        height: 18px;
        max-width: 18px;
        max-height: 18px;
      }

      svg {
        cursor: pointer;
        width: 18px;
        height: 18px;
        max-width: 18px;
        max-height: 18px;
        &:hover {
          path {
            fill: ${palette.neutral[200]};
          }
        }
      }
    `}
`

const ButtonGroupContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 16px;
  :not(:last-child) {
    border-right: 1px solid ${palette.neutral[100]};
    padding-right: 16px;
  }
`

export type Button = {
  button: React.ReactNode
  id: string
}

export type ButtonGroup = {
  buttons: Button[]
  id: string
}

export type ActionButtonGroupProps = {
  useNewStyle?: boolean
  groups: ButtonGroup[]
}

export const ActionButtonGroup = ({
  useNewStyle,
  groups,
}: ActionButtonGroupProps): JSX.Element => {
  return (
    <ActionButtonGroupContainer $useNewStyle={useNewStyle}>
      {groups.map((group) => (
        <ButtonGroupContainer key={group.id}>
          {group.buttons.map((button) => (
            <div key={button.id}>{button.button}</div>
          ))}
        </ButtonGroupContainer>
      ))}
    </ActionButtonGroupContainer>
  )
}
